import React, { useContext, useEffect, useCallback } from 'react';
import { useState } from 'react';
import { Tabs, Tab } from '@mui/material';
import { Box, Typography, Button } from '@mui/material';
import CommonAccordion from '../../custom-components/CommonAccordion'
import ImportAPIDefinition from './ImportAPIDefinition';
import ManualDetails from './ManualDetails';
import { ReactComponent as LoadIcon } from '../../../images/loadExampleButton.svg';
import { ReactComponent as APIResetFormIcon } from '../../../images/APIResetFormIcon.svg';
import { ReactComponent as GenerateButton } from '../../../images/generateButton.svg';
import URLHTMLSwaggerParser from './urlHTMLSwaggerParser';
import WebScrappingForWebPortal from './WebScrappingForWebPortal';
import LiveDiscoveryWithURL from './LiveDiscoveryWithURL';


const ApiDetails = (props) => {
  const apiDetailsExpanded = (props.generateTestCasesData || []).length === 0;
  const [tabIndex, setTabIndex] = useState(0);
  const [handlersFromManualDetails, setHandlersFromManualDetails] = useState({
    handleAPIDetailsLoadDemoExample: () => {},
  });
  
  const handleTabChange = (event, newIndex) => {
    setTabIndex(newIndex);
  };
  const registerHandlers = useCallback((handlers) => {
    setHandlersFromManualDetails(handlers);
  }, []);
  
  const buttonsgroup = [
    {
      label: 'Reset Form',
      variant: 'text',
      startIcon: <APIResetFormIcon />
    },
    {
      label: 'Generate Test Cases',
      variant: 'contained',
      disabled: true,
      startIcon: <GenerateButton />,
    }
  ];
  
  return (
    // <Box
    // sx={{
      //     display: "flex",
      // bgcolor: "#f6f3f2",
      // flexDirection: "column",
      // justifyContent: "center",
      // alignItems: "center",
      // overflowY: "auto",
      // width: "100%",
      
    // }}
    // >
    <CommonAccordion
      summary={<Box display="flex" justifyContent="space-between" alignItems="center" width="100%">
        <Typography variant="subtitle1" sx={{ fontSize: "16px" }}>
          Setup Method
        </Typography>
        {tabIndex === 1 && (
        
          <Button
            variant="text"
            startIcon={<LoadIcon />}
            onClick={handlersFromManualDetails.handleAPIDetailsLoadDemoExample}
            sx={{
             // ml: 2,
              textTransform: "none",
              // position: "relative",
              // top: "2px",
              // left: "680px",
              color: "#49A3FF"
            }}
          >
            Load Demo Example
          </Button>
         
        )}
      </Box>
      }
      type={"output"}
      details={
        <>
         <Box sx={{ borderBottom: 1, borderColor: "divider", bgcolor: "#ffffff", width: "100%", maxWidth: "100%", margin: "auto", }}>
            <Tabs value={tabIndex} onChange={handleTabChange} variant="fullWidth" >
              <Tab label="Import Specification" sx={{ textTransform: "none", fontSize: "1rem" }} />
              <Tab label="Manual Setup" sx={{ textTransform: "none", fontSize: "1rem" }} />
              <Tab label="Swagger URL"  sx={{ textTransform: "none", fontSize: "1rem" }} />
              <Tab label="API Documentation URL" disabled sx={{ textTransform: "none", fontSize: "1rem" }} />
              <Tab label="Live Discovery" disabled sx={{ textTransform: "none", fontSize: "1rem" }} />

            </Tabs>
          </Box>
          <Box sx={{
            mt: 2, display: "flex",
            justifyContent: "center", 
            alignItems: "center", 
          }}>
            {tabIndex === 0 && <ImportAPIDefinition />}
            {tabIndex === 1 && <ManualDetails registerHandlers={registerHandlers} />}
            {/* {tabIndex === 2 && <URLHTMLSwaggerParser />} */}
            {tabIndex === 2 && <URLHTMLSwaggerParser />}
            {tabIndex === 3 && <WebScrappingForWebPortal />}
            {tabIndex === 4 && <LiveDiscoveryWithURL />}
          </Box>
        </>
      }
      defaultExpanded={apiDetailsExpanded}
      fullScreenMode={true}
    />
  //  </Box>
  );
}

export default ApiDetails;
